<div class="sustainability-body">
    <div class="environment-part section-part" #environment>
      <div class="environment-data">
        <h1>Environment</h1>

        <div class="environment-panel">
          <div class="environment-nav col-sm-1">
            <!-- <div class="env-water-selection" (mouseenter)="selectEnv('water')" [@envOnHover]="envHover[0] ? 'hover':'before'"><img class="env-sel-img" [src]="waterIcon"></div> -->
            <!-- <div class="env-air-selection" (mouseenter)="selectEnv('air')" [@envOnHover]="envHover[1] ? 'hover':'before'"><img class="env-sel-img" [src]="airIcon"></div> -->
            <div class="env-air-selection" (mouseenter)="selectEnv('air')" [@envOnHover]="envHover[1] ? 'hover':'before'"><div class="env-sel-img"></div></div>
            <!-- <div class="env-waste-selection" (mouseenter)="selectEnv('waste')" [@envOnHover]="envHover[2] ? 'hover':'before'"><img class="env-sel-img" [src]="wasteIcon"></div>
            <div class="env-energy-selection" (mouseenter)="selectEnv('energy')" [@envOnHover]="envHover[3] ? 'hover':'before'"><img class="env-sel-img" [src]="energyIcon"></div> -->
          </div>

          <div class="environment-content col-sm-11" [ngSwitch]="selectedEnv">
            <!-- <div class="env-water-content panel-content" *ngSwitchCase="'water'" [@switchTab]="'fadeIn'">
              <h2>Water Management</h2>
              
              <table class="effluent-table">
                <tr class="effluent-month">
                  <th></th>
                  <th>2017</th>
                  <th>2018</th>
                  <th>2019</th>
                  <th>2020</th>
                </tr>

                <tr class="effluent-ph">
                  <th>Avg. pH</th>
                  <td>7.59</td>
                  <td>7.46</td>
                  <td>7.56</td>
                  <td>7.97</td>
                </tr>

                <tr class="effluent-AN">
                  <th>Avg. Anmoniacal Nitrogen, AN</th>
                  <td>16.0</td>
                  <td>16.0</td>
                  <td>43.0</td>
                  <td>47.0</td>
                </tr>

                <tr class="effluent-TN">
                  <th>Avg. Total Nitrogen, TN</th>
                  <td>20.0</td>
                  <td>18.0</td>
                  <td>52.0</td>
                  <td>48.0</td>
                </tr>

                <tr class="effluent-BOD">
                  <th>Avg. Biological Oxygen Demand, BOD</th>
                  <td>50.0</td>
                  <td>48.0</td>
                  <td>30.0</td>
                  <td>29.0</td>
                </tr>
              </table>
            </div> -->

            <div class="env-air-content panel-content" *ngSwitchCase="'air'" [@switchTab]="'fadeIn'">
              <h2>Air Quality</h2>

              <div class="left col-sm-4">
                <p class="number-indicator">> 70<span class="number-percent">%</span></p>
                <p class="percent-description">Air Pollutant Reduced</p>
              </div>

              <div class="air-right col-sm-8">
                <div class="air-description">
                  <p>Efforts, attempts and hard works were put in our air quality control system just to achieve 
                    a higher number of Air Pollutant Reduction from our site.
                  </p>
                </div>
              </div>
            </div>
            
            <!-- <div class="env-waste-content panel-content" *ngSwitchCase="'waste'" [@switchTab]="'fadeIn'">
              <h2>Waste Management</h2>  
            </div>

            <div class="env-energy-content panel-content" *ngSwitchCase="'energy'" [@switchTab]="'fadeIn'">
              <h2>Energy Management</h2>
            </div> -->
          </div>
        </div>
      </div>
      
      <div class="border-bottom"></div>
    </div>

    <div class="social-part section-part" #social>
      <div class="social-data">
        <h1>Social</h1>

        <div class="social-panel">
          <div class="social-nav col-sm-1">
            <!-- <div class="soc-employee-selection" (mouseenter)="selectSoc('employee')" [@socOnHover]="socHover[0] ? 'hover':'before'"><img class="soc-sel-img" [src]="employeeIcon"></div> -->
            <!-- <div class="soc-injury-selection" (mouseenter)="selectSoc('injury')" [@socOnHover]="socHover[1] ? 'hover':'before'"><img class="soc-sel-img" [src]="healthIcon"></div> -->
            <div class="soc-injury-selection" (mouseenter)="selectSoc('injury')" [@socOnHover]="socHover[1] ? 'hover':'before'"><div class="soc-sel-img"></div></div>
          </div>
  
          <div class="social-content col-sm-11" [ngSwitch]="selectedSoc">
            <!-- <div class="soc-employee-content panel-content" *ngSwitchCase="'employee'" [@switchTab]="'fadeIn'">
              <h2>Team</h2>
              <div class="employee-total col-sm-4">
                <div class="employee-total-icon"></div>
                <div class="employee-total-content">
                  <p>Total Members</p>
                  <p>285 persons</p>
                </div>
              </div>

              <div class="right-arrow col-sm-2"></div>

              <div class="employee-management col-sm-3">
                <div class="employee-management-icon"></div>
                <div class="employee-management-content">
                  <p>Management Team</p>
                  <p>42 persons</p>
                </div>
              </div>

              <div class="employee-production col-sm-3">
                <div class="employee-production-icon"></div>
                <div class="employee-production-content">
                  <p>Production Team</p>
                  <p>243 persons</p>
                </div>
              </div>
            </div> -->
  
            <div class="soc-injury-content panel-content" *ngSwitchCase="'injury'" [@switchTab]="'fadeIn'">
              <h2>Health & Safety</h2>

              <div class="health-left col-sm-8">
                <div class="health-description">
                  <p>With our safety measurements and equipments, the injury cases at our site are being controlled well at < 1% MAX for 
                    past few years. Safety is always top-priority in here.</p>
                </div>
              </div>

              <div class="health-right col-sm-4">
                <p class="number-indicator">< 1<span class="number-percent">%</span></p>
                <p class="percent-description">Injury Cases</p>
                <p class="percent-description">among team members</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border-bottom"></div>
    </div>

    <div class="economy-part section-part" #economy>      
      <div class="social-data">
        <h1>Governance</h1>

        <div class="economy-panel">
          <div class="economy-nav col-sm-1">
            <div class="eco-supplier-selection" (mouseenter)="selectEco('supplier')" [@ecoOnHover]="ecoHover[0] ? 'hover':'before'"><div class="eco-sel-img"></div></div>
            <!-- <div class="eco-customer-selection" (mouseenter)="selectEco('customer')" [@ecoOnHover]="ecoHover[1] ? 'hover':'before'"><img class="eco-sel-img" [src]="customerIcon"></div> -->
          </div>
  
          <div class="economy-content col-sm-11" [ngSwitch]="selectedEco">
            <div class="eco-supplier-content panel-content" *ngSwitchCase="'supplier'" [@switchTab]="'fadeIn'">
              <h2>Suppliers</h2>

              <div class="acknowledgement-percent col-sm-4">
                <p class="acknowledgement-number">~99<span class="acknowledgement-number-percent">%</span></p>
                <p class="acknowledgement-description">Acknowledgement</p>
              </div>
              
              <div class="acknowledgement-content col-sm-8">
                <div class="acknowledgement-words">
                  <p>from the suppliers and customers on our Sustainable Procurement Policy and Sustainability Policy.</p>
                </div>
              </div>
            </div>
  
            <!-- <div class="eco-customer-content" *ngSwitchCase="'customer'" [@switchTab]="'fadeIn'">
              
            </div> -->

            <!-- <div class="eco-customer-content panel-content" *ngSwitchCase="'customer'" [@switchTab]="'fadeIn'">
              <h2>We manufacture to ...</h2>
              
              <div class="asia-region col-sm-6">
                <p class="continent">🏴  Asia</p>

                <ul class="asia-country">
                  <li>Malaysia</li>
                  <li>Thailand</li>
                  <li>Indonesia</li>
                  <li>Myanmar</li>
                  <li>Philippines</li>
                  <li>Vietnam</li>
                </ul>
              </div>

              <div class="africa-region col-sm-6">
                <p class="continent">🏴  Africa</p>

                <ul class="africa-country">
                  <li>Ivory Coast</li>
                  <li>Ghana</li>
                  <li>Guatemala</li>
                  <li>Nigeria</li>
                  <li>Cameroon</li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>

    </div>
</div>